function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAirConditioning = function SvgAirConditioning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 128 128"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 27.4,
    cy: 67.3,
    r: 19.9,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4 88.7C15.6 88.7 6 79.1 6 67.3s9.6-21.4 21.4-21.4 21.4 9.6 21.4 21.4-9.6 21.4-21.4 21.4m0-39.8C17.2 48.9 9 57.2 9 67.3s8.3 18.4 18.4 18.4 18.4-8.3 18.4-18.4-8.3-18.4-18.4-18.4",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3 77.4c-.8 0-1.6-.3-2.2-.9l-6.9-6.9c-1.2-1.2-1.2-3.2 0-4.4s3.2-1.2 4.4 0l4.7 4.7 8.6-8.6c1.2-1.2 3.2-1.2 4.4 0s1.2 3.2 0 4.4L27.5 76.5c-.6.6-1.4.9-2.2.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3 78.9c-1.2 0-2.4-.5-3.3-1.4l-6.9-6.9c-.9-.9-1.4-2.1-1.4-3.3s.5-2.4 1.4-3.3 2-1.4 3.3-1.4c1.2 0 2.4.5 3.3 1.4l3.6 3.6 7.5-7.5c.9-.9 2-1.4 3.3-1.4 1.2 0 2.4.5 3.3 1.4s1.4 2 1.4 3.3c0 1.2-.5 2.4-1.4 3.3L28.6 77.5c-.9.9-2.1 1.4-3.3 1.4m-6.9-13.2c-.4 0-.9.2-1.2.5s-.5.7-.5 1.2c0 .4.2.9.5 1.2l6.9 6.9c.6.6 1.7.6 2.3 0l10.8-10.8c.3-.3.5-.7.5-1.2 0-.4-.2-.9-.5-1.2s-.7-.5-1.2-.5c-.4 0-.9.2-1.2.5l-8.6 8.6c-.6.6-1.5.6-2.1 0l-4.7-4.7c-.1-.3-.5-.5-1-.5M46 52.9h27.9c2.7 0 5.4-.9 7.6-2.6 2.3-1.9 4.7-4.8 5-9.4.5-7.6-6.9-12.3-12-12-4.3.3-10.1 3.7-10.7 11.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9 54.4H46c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h27.9c2.5 0 4.8-.8 6.6-2.2 2.7-2.2 4.2-5 4.4-8.3.2-3.4-1.4-5.7-2.7-7.1-2.1-2.1-5.2-3.4-7.7-3.2-3.4.2-8.8 3-9.3 9.8-.1.8-.8 1.4-1.6 1.4-.8-.1-1.4-.8-1.4-1.6.6-7.8 6.6-12.2 12.1-12.5 3.4-.2 7.3 1.4 10 4.1 2.6 2.6 3.8 5.9 3.6 9.4-.3 4.1-2.2 7.7-5.5 10.4-2.3 1.8-5.4 2.8-8.5 2.8M56 85h17.9c2.7 0 5.4.9 7.6 2.6 2.3 1.9 4.7 4.8 5 9.4.5 7.6-6.9 12.3-12 12-4.3-.3-10.1-3.7-10.7-11.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9 110.4h-.6c-5.5-.3-11.5-4.7-12.1-12.5-.1-.8.5-1.6 1.4-1.6.8-.1 1.6.5 1.6 1.4.6 6.8 5.9 9.6 9.3 9.8 2.5.1 5.6-1.2 7.7-3.2 1.4-1.4 3-3.7 2.7-7.1-.2-3.3-1.7-6.1-4.4-8.3-1.8-1.4-4.1-2.2-6.6-2.2H56c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h17.9c3.2 0 6.2 1 8.5 2.9 3.3 2.7 5.3 6.3 5.5 10.4.2 3.5-1 6.9-3.6 9.4-2.5 2.5-6.1 4-9.4 4M60.6 64.1h45.7c2.7 0 5.4-.9 7.6-2.6 2.3-1.9 4.7-4.8 5-9.4.5-7.6-6.9-12.3-12-12-4.3.3-10.1 3.7-10.7 11.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.4 65.6H60.6c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h45.7c2.5 0 4.8-.8 6.6-2.2 2.7-2.2 4.2-5 4.4-8.3.2-3.4-1.4-5.7-2.7-7.1-2.1-2.1-5.2-3.4-7.7-3.2-3.4.2-8.8 3-9.3 9.8-.1.8-.8 1.5-1.6 1.4s-1.4-.8-1.4-1.6c.6-7.8 6.6-12.2 12.1-12.5 3.4-.2 7.3 1.4 10 4.1 2.6 2.6 3.8 5.9 3.6 9.4-.3 4.1-2.2 7.7-5.5 10.4-2.2 1.7-5.3 2.8-8.4 2.8M52 73.6h53.5s11.8 1.2 13 9.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.5 84.3c-.7 0-1.4-.5-1.5-1.3-1-6.5-10.7-7.9-11.6-8H52c-.8 0-1.5-.7-1.5-1.5S51.2 72 52 72h53.7c.5.1 12.9 1.5 14.3 10.5.1.8-.4 1.6-1.3 1.7 0 .1-.1.1-.2.1M95.9 83.5s-1.2 13.6 13.3 13.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.2 98.6c-4.9 0-8.7-1.4-11.3-4.3-4.1-4.5-3.6-10.7-3.5-11 .1-.8.8-1.4 1.6-1.4.8.1 1.4.8 1.4 1.6 0 .1-.4 5.2 2.8 8.7q3 3.3 9 3.3c.8 0 1.5.7 1.5 1.5s-.6 1.6-1.5 1.6",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.5,
    cy: 91.5,
    r: 1.7,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.5 94.7c-1.8 0-3.2-1.4-3.2-3.2s1.4-3.2 3.2-3.2 3.2 1.4 3.2 3.2-1.4 3.2-3.2 3.2m0-3.4c-.1 0-.2.1-.2.2 0 .2.4.2.4 0 0-.1-.1-.2-.2-.2",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgAirConditioning;